import React from 'react'
import { useGlobalVariablesContext } from '../../../context/GlobalVariablesContext'
import { useTranslation } from 'react-i18next'

import './CatastroReferencia.css'

function CatastroReferencia({ title, toggleable, type, hasSidebar, buttonName, buttonText }) {
  const {layerCadastro, setLayerCadastro} = useGlobalVariablesContext();
  const { t } = useTranslation();

  const handleButtonCatastro = (event) => {
    // Cambia el estado de la herramienta catastro: si está activa la desactiva, si está desactivada la activa (toggle)
    setLayerCadastro(!layerCadastro)
    // Quitar el foco del botón para que no mantenga el estilo de focused
    event.target.blur()
  }

  return (
    <>
      <button
        type="button"
        className={`btn btn-catastral btn-primary ${layerCadastro ? 'active' : ''} mt-3 mb-3`}
        title={title}
        name={buttonName}
        onClick={handleButtonCatastro}
      >
        <i className="bi bi-eye"></i> {buttonText}
      </button>
      <br />
      <span className="small text-muted ">* {t('catastro_hint')}</span>
    </>
  )
}

export default CatastroReferencia